import { PurchaseErrorCodesLookup } from '~/common/helpers';
import { useErrorTranslation } from '~/common/hooks';

export const usePurchaseErrorTranslation = () =>
  useErrorTranslation(PurchaseErrorCodesLookup);
